export const INVALID_WIFI_PASSWORD_MESSAGE = `A senha deve conter pelo menos uma letra maiúscula, uma letra minúscula e um número. Não pode conter caracteres especiais, emojis, espaços e vírgulas.`

export const INVALID_WIFI_NAME_MESSAGE = `Deve iniciar com uma letra e conter apenas letras, números e '_'.`
